import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { useStudentBio } from "./use_student_bio";

export const useStudentBiography = () => {
  const { nis, gender, isSuccess: isSuccessNis } = useStudentBio();

  const { data, isPending, refetch } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIOGRAPHY, nis],
    queryFn: () => SchoolService.studentBiography(nis),
    enabled: !!nis,
    staleTime: 5 * 60 * 1000,
  });

  return {
    biography: data?.data ?? null,
    isPending: !isSuccessNis || isPending,
    gender,
    refetch,
  };
};
